import {
  HiUsers,
  HiIdentification,
  HiOfficeBuilding,
  HiChartBar,
  HiChartPie,
  HiCube,
  HiViewGrid,
  HiClipboardList,
  HiRefresh,
  HiInformationCircle,
  HiCurrencyDollar,
  HiTruck,
  HiClipboardCheck,
  HiAdjustments,
  HiUserGroup,
  HiDocumentReport,
  HiShoppingCart,
  HiDatabase,
  HiFolder,
  HiTemplate,
  HiTag,
  HiQrcode,
  HiDeviceMobile,
  HiDownload,
  HiChatAlt2,
  HiMail,
  HiSparkles,
  HiTrendingUp,
  HiUser,
  HiClock,
  HiCalendar,
  HiCog,
  HiPhotograph
} from "react-icons/hi";
import { moduleForPath, estCommercial } from "./adminModules";

// =============================================
// CONFIGURATION DES MENUS AVEC SOUS-GROUPES
// =============================================

// Structure des menus ADMIN avec sous-groupes.
// NB : le tableau de bord n'est plus ici — il est UNIQUE (route "/") et vit
// dans « Mon espace », voir PERSONAL_ITEMS.
export const adminMenuStructure = [
  {
    type: "subgroup",
    label: "Gestion",
    icon: HiFolder,
    collapsible: true,
    items: [
      { label: "Utilisateurs", path: "/admin/users", icon: HiUsers },
      { label: "Badges utilisateurs", path: "/admin/badges", icon: HiIdentification },
      { label: "Équipes", path: "/admin/equipes", icon: HiUserGroup },
      { label: "Tâches", path: "/admin/taches", icon: HiClipboardCheck },
      { label: "Entreprises", path: "/admin/entreprises", icon: HiOfficeBuilding },
      { label: "Organisation du menu", path: "/admin/infobulles", icon: HiInformationCircle },
      { label: "Paramètres Email (SMTP)", path: "/admin/smtp", icon: HiMail },
      { label: "Concurrents", path: "/admin/concurrents", icon: HiUserGroup },
      { label: "Installation app", path: "/install", icon: HiQrcode },
    ],
  },
  {
    type: "subgroup",
    label: "Données",
    icon: HiDatabase,
    collapsible: true,
    items: [
      { label: "Articles", path: "/admin/articles", icon: HiCube },
      { label: "Fournisseurs", path: "/admin/fournisseurs", icon: HiFolder },
      { label: "Clients", path: "/admin/clients", icon: HiUserGroup },
      { label: "Réservations", path: "/admin/reservations", icon: HiClipboardList },
      { label: "Commandes", path: "/admin/commandes", icon: HiTruck },
      { label: "Envoi Cde Fournisseur", path: "/admin/envoi-cde-fournisseur", icon: HiMail },
      { label: "Proformas", path: "/admin/proformas", icon: HiDocumentReport },
      { label: "Factures", path: "/admin/factures", icon: HiCurrencyDollar },
      // « Bipages » tout court se confondait avec « Détail des bipages » (les
      // lignes lues) : ici on CRÉE les demandes envoyées aux collecteurs.
      { label: "Demandes de bipage", path: "/admin/demandes-bipage", icon: HiClipboardList },
      { label: "Suivi bipage terrain", path: "/admin/suivi-demandes-bipage", icon: HiClipboardCheck },
      { label: "Suivi Réceptions", path: "/admin/suivi-receptions", icon: HiClipboardCheck },
      { label: "Suivi des entrées", path: "/admin/suivi-entrees", icon: HiTruck },
      { label: "Entrées sur réservation", path: "/admin/resa-entrees", icon: HiClipboardCheck },
      { label: "Gisements & Groupes", path: "/admin/export-gisements", icon: HiDownload },
      { label: "Dictionnaire des rayons", path: "/admin/dictionnaire-rayons", icon: HiTag },
      { label: "Exécutables", path: "/admin/executables", icon: HiDownload },
      { label: "Documents FTP", path: "/admin/documents-ftp", icon: HiFolder },
      { label: "Annuaires", path: "/dictionnaires", icon: HiUsers },
    ],
  },
  {
    type: "subgroup",
    label: "Commerciaux",
    icon: HiTrendingUp,
    collapsible: true,
    items: [
      { label: "Top Ventes", path: "/admin/top-ventes", icon: HiTrendingUp },
    ],
  },
  {
    type: "subgroup",
    label: "Analyse",
    icon: HiChartBar,
    collapsible: true,
    items: [
      { label: "Analyse Commerciaux", path: "/admin/commerciaux", icon: HiUserGroup },
      { label: "Analyse Filiales", path: "/admin/filiales", icon: HiOfficeBuilding },
      { label: "Analyse CA", path: "/admin/analyse-ca", icon: HiChartBar },
      { label: "Analyse CA mensuelle", path: "/admin/analyse-ca-mensuelle", icon: HiChartBar },
      { label: "Historique promos", path: "/admin/historique-promos", icon: HiTag },
      { label: "Stats commerciaux", path: "/admin/stats-commerciaux", icon: HiUserGroup },
      { label: "Analyse stock", path: "/admin/analyse-stock", icon: HiChartBar },
      { label: "Analyse Facturation", path: "/admin/facture-analyse", icon: HiDocumentReport },
      { label: "Analyse Proforma", path: "/admin/analyse-proforma", icon: HiDocumentReport },
      { label: "Journal de Caisse", path: "/admin/journal-caisse", icon: HiCurrencyDollar },
      { label: "Rapports TGC", path: "/admin/rapport-tgc", icon: HiCurrencyDollar },
      { label: "Balances clients", path: "/admin/balances-clients", icon: HiCurrencyDollar },
      { label: "Dernière facturation", path: "/admin/derniere-facturation", icon: HiCalendar },
      { label: "Fréquentation magasin", path: "/admin/frequentation", icon: HiClock },
      { label: "Top Articles", path: "/admin/top-articles", icon: HiChartBar },
      { label: "Reappro Local", path: "/admin/reappro-local", icon: HiTruck },
      { label: "Analyse Réappro", path: "/admin/analyse-reappro", icon: HiRefresh },
      { label: "Débit / Comptant", path: "/admin/debit-comptant", icon: HiCurrencyDollar },
      { label: "Doublons GENCODE", path: "/admin/gencod-doublons", icon: HiDatabase },
      { label: "Performance réappro magasin", path: "/admin/performance-dock", icon: HiClipboardCheck },
      { label: "Collecteurs", path: "/admin/collecteurs", icon: HiDeviceMobile },
      { label: "Carte des collecteurs", path: "/admin/collecteurs-carte", icon: HiDeviceMobile },
    ],
  },
];

// Structure des menus MODULES avec sous-groupes
// ⚠️ L'écran « Recherche Article » (/articles) a été RETIRÉ de l'application
// web le 10/09/2026 (décision client), et avec lui le chapitre « Stock » qui ne
// portait que lui. Ce qui reste, et qu'il ne faut pas supprimer :
//   - Données ▸ Articles et Données ▸ Fournisseurs, qui dépendent du même
//     module de permission `stock` ;
//   - la recherche article de l'APP MOBILE, servie par les mêmes routes
//     /api/articles et gardée par ce module.
// Autrement dit : c'est l'écran web qui part, pas le module.
export const moduleMenuStructure = [
  {
    type: "subgroup",
    label: "Inventaire Zones",
    icon: HiClipboardList,
    collapsible: true,
    items: [
      {
        // En tête : c'est la vue d'ensemble, on l'ouvre en premier.
        label: "Tableau de bord",
        path: "/admin/inventaire-dashboard",
        icon: HiChartPie,
      },
      {
        label: "Fiches inventaires",
        path: "/admin/zones",
        icon: HiTemplate,
      },
      {
        label: "Progression inventaire",
        path: "/admin/inventaire-progression",
        icon: HiChartBar,
      },
      {
        label: "Détail des bipages",
        path: "/admin/bipages",
        icon: HiClipboardList,
      },
      {
        label: "Fiches de contrôle",
        path: "/admin/fiches-controle",
        icon: HiDocumentReport,
      },
      {
        label: "Récap par zone",
        path: "/admin/recap-zones",
        icon: HiViewGrid,
      },
      {
        // « Suivi bipage » tout court se confondait avec le bipage TERRAIN
        // (demandes envoyées aux collecteurs) : celui-ci suit le comptage
        // d'INVENTAIRE par zone et se vide à chaque réinitialisation.
        label: "Suivi bipage inventaire",
        path: "/admin/suivi-bipage",
        icon: HiClock,
      },
      // « Agents de l'inventaire » ne figure PLUS au menu (décision du
      // 11/09/2026) : on y accède depuis le tableau de bord de l'inventaire,
      // qui en porte déjà la synthèse. La ROUTE et son entrée dans
      // PATH_MODULE_MAP restent — sans elles, le lien du tableau de bord
      // tomberait sur une page inconnue.
    ],
  },
  {
    type: "subgroup",
    label: "Inventaire proforma",
    icon: HiDocumentReport,
    collapsible: true,
    items: [
      {
        label: "Inventaire Proforma",
        path: "/admin/inventaire-proforma",
        icon: HiDocumentReport,
      },
    ],
  },
  // {
  //   type: "subgroup",
  //   label: "Commandes",
  //   icon: HiShoppingCart,
  //   collapsible: true,
  //   items: [
  //     {
  //       moduleKey: "ctr_commande",
  //       label: "CTRL Commandes",
  //       path: "/controle-commandes",
  //       icon: HiClipboardCheck,
  //     },
  //     {
  //       moduleKey: "prep_commande",
  //       label: "PREPA Commandes",
  //       path: "/preparation-commandes",
  //       icon: HiShoppingCart,
  //     },
  //   ],
  // },
  {
    type: "subgroup",
    label: "Réappro",
    icon: HiRefresh,
    collapsible: true,
    items: [
      {
        moduleKey: "demande_reappro",
        label: "Listes de réappro",
        path: "/demandes-reappro",
        icon: HiClipboardList,
      },
      {
        moduleKey: "demande_reappro",
        label: "Suivi des réappros",
        path: "/admin/suivi-reappro",
        icon: HiClock,
      },
      {
        // Réappro depuis un entrepôt (S2..S5) vers le rayon : analyse,
        // ajustement à l'écran puis fichier .dat pour Stock XL.
        moduleKey: "reapro",
        label: "Réappro Mécalac",
        path: "/reappro-mecalac",
        icon: HiTruck,
      },
    ],
  },
  {
    type: "subgroup",
    label: "Préparation",
    icon: HiClipboardList,
    collapsible: true,
    items: [
      {
        moduleKey: "prep_commande_manuelle",
        label: "Préparation manuelle",
        path: "/preparation-manuelle",
        icon: HiClipboardList,
      },
      {
        moduleKey: "prep_commande_manuelle",
        label: "Suivi des préparations",
        path: "/admin/suivi-preparation",
        icon: HiClock,
      },
    ],
  },
  {
    type: "subgroup",
    label: "Réception",
    icon: HiTruck,
    collapsible: true,
    items: [
      {
        moduleKey: "reception_manuelle",
        label: "Contrôle manuel",
        path: "/reception-manuelle",
        icon: HiClipboardCheck,
      },
    ],
  },
  {
    type: "subgroup",
    label: "Relevé",
    icon: HiChartBar,
    collapsible: true,
    items: [
      // {
      //   moduleKey: "ctrl_info_produit",
      //   label: "CTRL Infos Produit",
      //   path: "/controle-infos-produit",
      //   icon: HiInformationCircle,
      // },
      {
        moduleKey: "releve",
        label: "Relevé Prix",
        path: "/releve",
        icon: HiCurrencyDollar,
      },
    ],
  },
  {
    type: "subgroup",
    label: "Étiquettes",
    icon: HiTag,
    collapsible: true,
    items: [
      {
        moduleKey: "etiquettes",
        label: "Générateur d'étiquettes",
        path: "/etiquettes",
        icon: HiTag,
      },
      {
        moduleKey: "changement_prix",
        label: "Changement de prix",
        path: "/changement-prix",
        icon: HiCurrencyDollar,
      },
      {
        moduleKey: "historique_pachat",
        label: "Historique prix d'achat",
        path: "/historique-pachat",
        icon: HiTrendingUp,
      },
      {
        moduleKey: "edition_promo",
        label: "Édition Promo",
        path: "/edition-promo",
        icon: HiCurrencyDollar,
      },
    ],
  },
  {
    type: "subgroup",
    label: "Communication",
    icon: HiMail,
    collapsible: true,
    items: [
      {
        moduleKey: "mailing",
        label: "Mailing clients",
        path: "/mailing",
        icon: HiMail,
      },
      {
        moduleKey: "communication_client",
        label: "Nouveautés clients",
        path: "/communication-client",
        icon: HiMail,
      },
      {
        moduleKey: "assistant_ia",
        label: "Assistant IA",
        path: "/assistant-ia",
        icon: HiSparkles,
      },
      {
        moduleKey: "veille",
        label: "Veille",
        path: "/veille",
        icon: HiDocumentReport,
      },
      {
        moduleKey: "mediatheque",
        label: "Médiathèque",
        path: "/mediatheque",
        icon: HiPhotograph,
      },
    ],
  },
];

// Ancienne structure plate pour compatibilité (moduleMenus)
export const moduleMenus = {
  proformas: {
    label: "Proformas",
    path: "/proformas",
    icon: HiAdjustments,
  },
  reapro: {
    label: "Reapro",
    path: "/reappro",
    icon: HiRefresh,
  },
  ctr_commande: {
    label: "CTRL Commandes",
    path: "/controle-commandes",
    icon: HiClipboardCheck,
  },
  prep_commande: {
    label: "PREPA Commandes",
    path: "/preparation-commandes",
    icon: HiShoppingCart,
  },
  ctrl_info_produit: {
    label: "CTRL Infos Produit",
    path: "/controle-infos-produit",
    icon: HiInformationCircle,
  },
  releve: {
    label: "Releve Prix",
    path: "/releve",
    icon: HiCurrencyDollar,
  },
  etiquettes: {
    label: "Générateur d'étiquettes",
    path: "/etiquettes",
    icon: HiTag,
  },
};

// =============================================
// HELPERS
// =============================================

export const isAdmin = (userInfo) => {
  return userInfo?.role === "admin";
};

export const hasAllModulesAccess = (userInfo) => {
  if (!userInfo?.permissions) return false;
  return userInfo.permissions.allModules === true;
};

export const hasAllEntreprisesAccess = (userInfo) => {
  if (!userInfo?.permissions) return false;
  return userInfo.permissions.allEntreprises === true;
};

export const hasModulePermission = (userInfo, module, action = "read") => {
  if (!userInfo) return false;
  if (isAdmin(userInfo)) return true;
  if (hasAllModulesAccess(userInfo)) return true;

  const permissions = userInfo.permissions;
  if (!permissions?.modules?.[module]) return false;

  return permissions.modules[module][action] === true;
};

export const hasEntrepriseAccess = (userInfo, entreprise) => {
  if (!userInfo) return false;
  if (isAdmin(userInfo)) return true;
  if (hasAllEntreprisesAccess(userInfo)) return true;

  const permissions = userInfo.permissions;
  return permissions?.entreprises?.includes(entreprise) || false;
};

export const hasRouteAccess = (userInfo, path, action = "read") => {
  if (!userInfo) return false;
  if (isAdmin(userInfo)) return true;
  if (path.startsWith("/admin")) return false;

  const module = Object.keys(moduleMenus).find((key) => {
    const menu = moduleMenus[key];
    return path === menu.path || path.startsWith(`${menu.path}/`);
  });

  if (!module) return true;

  return hasModulePermission(userInfo, module, action);
};

// =============================================
// GÉNÉRATION DES MENUS AVEC SOUS-GROUPES
// =============================================

/**
 * Génère les menus pour un utilisateur avec la nouvelle structure
 * supportant les sous-groupes
 */
export const getUserMenus = (userInfo) => {
  if (!userInfo) return [];

  const menus = [];

  // 0. Espace personnel — « Mes tâches », visible par TOUT utilisateur connecté.
  menus.push({
    type: "section",
    label: "Mon espace",
    collapsible: true,
    items: [
      { label: "Tableau de bord", path: "/", icon: HiViewGrid, exact: true },
      { label: "Mes tâches", path: "/mes-taches", icon: HiClipboardCheck },
      { label: "Espace équipe", path: "/espace-equipe", icon: HiChatAlt2 },
      { label: "Mon profil", path: "/profile", icon: HiUser },
      { label: "Organiser mon menu", path: "/mon-menu", icon: HiViewGrid },
    ],
  });

  // 0 bis. Espace commercial — visible uniquement si l'utilisateur est rattaché
  // à au moins un code vendeur (profil commercial).
  if (estCommercial(userInfo)) {
    menus.push({
      type: "section",
      label: "Espace commercial",
      collapsible: true,
      items: COMMERCIAL_ITEMS.map((it) => ({ ...it })),
    });
  }

  // 1. Section Administration — filtrée par permission de module.
  //    Visible pour un admin OU tout utilisateur ayant au moins une entrée
  //    autorisée (chaque entrée -> clé via moduleForPath -> hasModulePermission).
  const adminItems = filterAdminStructure(userInfo, adminMenuStructure);
  if (adminItems.length > 0) {
    menus.push({
      type: "section",
      label: "Administration",
      collapsible: true,
      items: adminItems,
    });
  }

  // 2. Section Modules selon permissions
  const moduleItems = getModuleMenuItems(userInfo);
  if (moduleItems.length > 0) {
    menus.push({
      type: "section",
      label: "Modules",
      collapsible: true,
      items: moduleItems,
    });
  }

  return menus;
};

// Écrans d'administration accessibles à un RESPONSABLE (gestion de son équipe).
// Les données sont scopées côté API (users de son équipe / ses équipes).
const RESPONSABLE_ADMIN_PATHS = [
  "/admin/users",
  "/admin/equipes",
  "/admin/taches",
];

// Un utilisateur peut-il voir une entrée du menu admin ?
// - responsable -> gestion d'équipe (utilisateurs scopés + équipes) ;
// - entrée mappée à un module (via son path) -> permission requise ;
// - entrée sans module (ex. /install) -> réservée aux admins.
const canSeeAdminItem = (userInfo, item) => {
  if (!item?.path) return isAdmin(userInfo);
  if (
    userInfo?.role === "responsable" &&
    RESPONSABLE_ADMIN_PATHS.includes(item.path)
  ) {
    return true;
  }
  const key = moduleForPath(item.path);
  if (key) return hasModulePermission(userInfo, key, "read");
  return isAdmin(userInfo);
};

// Filtre la structure admin (items + sous-groupes) selon les permissions.
const filterAdminStructure = (userInfo, structure) => {
  const out = [];
  structure.forEach((node) => {
    if (node.type === "subgroup") {
      const items = (node.items || []).filter((it) =>
        canSeeAdminItem(userInfo, it),
      );
      if (items.length > 0) out.push({ ...node, items });
    } else {
      // type "item" (Dashboard, etc.)
      if (canSeeAdminItem(userInfo, node)) out.push(node);
    }
  });
  return out;
};

/**
 * Récupère les items de modules accessibles avec sous-groupes
 */
const getModuleMenuItems = (userInfo) => {
  if (!userInfo) return [];

  const result = [];
  const hasFullAccess = isAdmin(userInfo) || hasAllModulesAccess(userInfo);

  // Clé de permission d'une entrée : moduleKey explicite, sinon déduite du path.
  const keyOf = (entry) =>
    entry.moduleKey || (entry.path ? moduleForPath(entry.path) : null);

  const canSee = (entry) => {
    if (hasFullAccess) return true;
    const key = keyOf(entry);
    return key ? hasModulePermission(userInfo, key, "read") : false;
  };

  moduleMenuStructure.forEach((item) => {
    if (item.type === "subgroup") {
      // Filtrer les items du sous-groupe selon les permissions
      const accessibleItems = item.items.filter((subItem) => canSee(subItem));

      // N'ajouter le sous-groupe que s'il a des items accessibles
      if (accessibleItems.length > 0) {
        result.push({
          ...item,
          items: accessibleItems,
        });
      }
    } else if (item.type === "item") {
      // Item simple - vérifier la permission
      if (canSee(item)) {
        result.push(item);
      }
    }
  });

  return result;
};

/**
 * Ancienne fonction pour compatibilité - retourne une liste plate
 */
export const getModuleMenus = (userInfo) => {
  if (!userInfo) return [];

  const menus = [];

  if (isAdmin(userInfo) || hasAllModulesAccess(userInfo)) {
    Object.values(moduleMenus).forEach((menu) => {
      menus.push({ ...menu });
    });
    return menus;
  }

  const permissions = userInfo.permissions;
  if (!permissions?.modules) return menus;

  Object.entries(moduleMenus).forEach(([moduleKey, menu]) => {
    const modulePerms = permissions.modules[moduleKey];
    if (modulePerms?.read) {
      menus.push({ ...menu });
    }
  });

  return menus;
};

export const getAccessibleEntreprises = (userInfo, allEntreprises = []) => {
  if (!userInfo) return [];

  if (isAdmin(userInfo) || hasAllEntreprisesAccess(userInfo)) {
    return allEntreprises;
  }

  const permissions = userInfo.permissions;
  if (!permissions?.entreprises) return [];

  return allEntreprises.filter((entreprise) =>
    permissions.entreprises.includes(entreprise.nom || entreprise),
  );
};

// =============================================
// INFOBULLES DES ONGLETS (survol) — textes par défaut
// =============================================
// Texte court affiché au survol de chaque onglet. Peut être surchargé par
// l'administrateur (stocké en base, clé = path). Voir Sidebar + AdminInfobulles.
export const DEFAULT_MENU_HINTS = {
  "/": "Ma société active et mes accès rapides.",
  "/mes-taches": "Vos tâches personnelles à traiter.",
  // Espace commercial
  "/commercial": "Mon activité commerciale : portefeuille, relances, alertes.",
  "/commercial/clients": "Mes clients (clients dont je suis le représentant).",
  "/commercial/proformas": "Mes proformas et devis, dont ceux à relancer.",
  "/commercial/reservations": "Les réservations en cours de mes clients.",
  "/commercial/commandes-speciales":
    "Mes commandes spéciales et leur avancement.",
  "/commercial/factures": "Les factures réalisées sous mon code vendeur.",
  "/commercial/analyses":
    "CA, marge et quantités de mon portefeuille par fournisseur, rayon, client ou article.",
  "/commercial/prime":
    "Suivi et simulation de ma prime — mes propres taux et paliers.",
  "/commercial/alertes":
    "Articles réservés par mes clients qui viennent d'entrer en stock.",
  "/espace-equipe": "Messagerie et espace de travail de vos équipes.",
  // Gestion
  "/admin/users": "Gérer les comptes utilisateurs et leurs accès.",
  "/admin/badges":
    "Code-barres des comptes : feuille de poste à biper et cartes à découper.",
  "/admin/equipes": "Créer et gérer les équipes.",
  "/admin/taches": "Suivre et assigner les tâches.",
  "/admin/entreprises": "Configurer les sociétés et leurs chemins de données.",
  "/admin/infobulles": "Réorganiser, masquer et décrire les onglets du menu.",
  "/admin/smtp": "Paramètres d'envoi d'emails (SMTP) global et par module.",
  "/admin/concurrents": "Relevés et suivi des prix concurrents.",
  "/install": "Installer l'application mobile (QR code).",
  // Données
  "/admin/articles": "Rechercher et consulter les articles.",
  "/admin/fournisseurs": "Consulter les fournisseurs.",
  "/admin/clients": "Consulter les clients.",
  "/admin/reservations": "Réservations clients (proformas en cours).",
  "/admin/commandes": "Commandes fournisseurs et leur suivi.",
  "/admin/envoi-cde-fournisseur":
    "Envoyer les commandes préparées aux fournisseurs par email.",
  "/admin/proformas": "Proformas / devis clients.",
  "/admin/factures": "Factures clients.",
  "/admin/demandes-bipage": "Demandes d'articles à biper (collecteur).",
  "/admin/bipages": "Détail des bipages remontés.",
  "/admin/suivi-receptions": "Suivi des réceptions de marchandises.",
  "/reception-manuelle":
    "Imprimer les fiches de contrôle papier des commandes à réceptionner.",
  "/admin/suivi-preparation":
    "Préparations en cours et terminées : au collecteur ET fiches papier marquées « préparées ».",
  "/preparation-manuelle":
    "Imprimer les fiches de préparation papier des proformas à préparer (dock puis magasin).",
  "/admin/frequentation":
    "Plages horaires de fréquentation du magasin, d'après les factures éditées.",
  "/admin/suivi-entrees":
    "Marchandises entrées du jour (entrees.dbf) enrichies + contrôle TGC.",
  "/admin/resa-entrees":
    "Articles réservés / commande spéciale qui entrent en stock (client + vendeur).",
  "/admin/export-gisements": "Export Excel des gisements et groupes.",
  "/admin/dictionnaire-rayons": "Dictionnaire des rayons (libellés, métrage).",
  "/admin/executables": "Téléchargements et exécutables.",
  // Inventaire
  "/admin/inventaire-dashboard":
    "Vue d'ensemble de l'inventaire en cours : avancement, zones, agents.",
  "/admin/zones": "Fiches d'inventaire par zone.",
  "/admin/inventaire-progression": "Progression de l'inventaire en cours.",
  "/admin/recap-zones": "Récapitulatif de l'inventaire par zone.",
  "/admin/suivi-bipage":
    "INVENTAIRE : qui a bipé quelle zone, quand, en combien de temps, avec ses observations.",
  "/admin/suivi-demandes-bipage":
    "TERRAIN : ce que les collecteurs ont bipé sur les demandes envoyées depuis le web.",
  "/admin/fiches-controle": "Fiches de contrôle d'inventaire.",
  "/admin/inventaire-proforma": "Inventaire à partir d'une proforma.",
  // Commerciaux
  "/admin/top-ventes": "Classement des ventes par fournisseur ou rayon.",
  // Analyse
  "/admin/commerciaux": "Chiffre d'affaires par commercial (REPRES).",
  "/admin/filiales": "Analyse des filiales.",
  "/admin/analyse-ca": "Analyse du chiffre d'affaires.",
  "/admin/analyse-ca-mensuelle":
    "Analyse CA mensuelle détaillée : types de client, clients, fournisseurs, classes, familles, rayons…",
  "/admin/historique-promos":
    "Bilan mensuel des promotions : CA et marge sur les articles en promo, top des articles du mois.",
  "/admin/stats-commerciaux":
    "Performance des commerciaux : portefeuille clients, CA/marge N vs N-1, top clients, nouveaux/perdus, concentration.",
  "/admin/analyse-stock":
    "Analyse mensuelle du stock : valeur, surstock, dépréciation, rotation, stock dormant, tops fournisseurs et articles.",
  "/admin/facture-analyse": "Analyse de la facturation.",
  "/admin/analyse-proforma":
    "Entêtes de proforma par plage de dates et code vendeur, export Excel.",
  "/admin/documents-ftp":
    "Documents générés par l'application (fichiers .dat, rapports, fiches) archivés sur le FTP, par société.",
  "/dictionnaires":
    "Annuaires du personnel de toutes les sociétés (postes, téléphones, emails), PDF téléchargeable.",
  "/admin/journal-caisse": "Journal de caisse.",
  "/admin/rapport-tgc":
    "Déclaration TGC mensuelle (base HT & TGC par taux) + alertes.",
  "/admin/balances-clients":
    "Encours clients par ancienneté + clients à bloquer (dette ≥ 2 mois).",
  "/admin/top-articles": "Meilleures ventes par article (facture).",
  "/admin/reappro-local": "Réapprovisionnement local.",
  "/admin/analyse-reappro": "Analyse des réapprovisionnements.",
  "/demandes-reappro":
    "Listes de réappro à préparer : urgence, avancement et création manuelle.",
  "/admin/suivi-reappro":
    "Réappros en cours et terminés au collecteur : listes ET réappros libres.",
  "/reappro-mecalac":
    "Articles à descendre d'un entrepôt (S2..S5) vers le rayon, puis fichier .dat pour Stock XL.",
  "/admin/debit-comptant": "Répartition débit / comptant.",
  "/admin/gencod-doublons": "Détection des doublons de gencode.",
  "/admin/derniere-facturation":
    "Clients de la société et date de leur dernière facture, du plus ancien au plus récent.",
  "/admin/performance-dock": "Articles réapprovisionnés par jour au magasin : volume, moyenne et écarts.",
  "/admin/collecteurs": "Collecteurs (terminaux de scan).",
  "/admin/collecteurs-carte": "Carte de localisation des collecteurs.",
  // Modules (gestion utilisateur)
  "/releve": "Relevé de prix terrain.",
  "/etiquettes": "Générateur d'étiquettes.",
  "/changement-prix":
    "Changements de prix de vente (rapport Excel + étiquettes).",
  "/historique-pachat":
    "Évolution du prix d'achat (PACHAT) d'un article, par fournisseur.",
  "/edition-promo": "Édition des promotions.",
  "/mailing": "Emailing clients (campagnes).",
  "/assistant-ia": "Assistant IA branché sur les données société.",
  "/veille":
    "Veille hebdomadaire rédigée par l'IA : un rapport HTML sur vos thématiques.",
  "/mediatheque":
    "Banque d'images et de signatures HTML en ligne : copiez le lien public pour vos signatures mail.",
  "/communication-client":
    "Catalogue des nouveautés en stock, envoyé aux clients abonnés.",
};

// Onglets de l'ESPACE COMMERCIAL — section fixe, affichée uniquement aux
// utilisateurs au profil commercial (Permission.commercial). Non gérée par le
// constructeur de menu : ces écrans ne dépendent d'aucun module.
export const COMMERCIAL_ITEMS = [
  { label: "Mon tableau de bord", path: "/commercial", icon: HiViewGrid, exact: true },
  { label: "Mon portefeuille", path: "/commercial/clients", icon: HiUserGroup },
  { label: "Mes proformas", path: "/commercial/proformas", icon: HiDocumentReport },
  { label: "Mes réservations", path: "/commercial/reservations", icon: HiClipboardList },
  { label: "Mes commandes spéciales", path: "/commercial/commandes-speciales", icon: HiSparkles },
  { label: "Mes factures", path: "/commercial/factures", icon: HiCurrencyDollar },
  { label: "Mes analyses", path: "/commercial/analyses", icon: HiChartBar },
  { label: "Ma prime", path: "/commercial/prime", icon: HiTrendingUp },
  { label: "Mes alertes", path: "/commercial/alertes", icon: HiInformationCircle },
];

// Onglets de l'espace personnel (section fixe, non gérée par le constructeur).
const PERSONAL_ITEMS = [
  { label: "Tableau de bord", path: "/", icon: HiViewGrid, exact: true },
  { label: "Mes tâches", path: "/mes-taches", icon: HiClipboardCheck },
  { label: "Espace équipe", path: "/espace-equipe", icon: HiChatAlt2 },
  { label: "Mon profil", path: "/profile", icon: HiUser },
  { label: "Organiser mon menu", path: "/mon-menu", icon: HiViewGrid },
];

// Aplatit toutes les structures de menu -> liste { path, label, group } unique.
// Sert à l'écran d'administration des infobulles.
export const getAllMenuItems = () => {
  const out = [];
  const seen = new Set();
  const push = (item, group) => {
    if (!item?.path || seen.has(item.path)) return;
    seen.add(item.path);
    out.push({ path: item.path, label: item.label, group });
  };
  PERSONAL_ITEMS.forEach((it) => push(it, "Mon espace"));
  COMMERCIAL_ITEMS.forEach((it) => push(it, "Espace commercial"));
  const walk = (nodes, group) => {
    (nodes || []).forEach((node) => {
      if (node.type === "subgroup") walk(node.items, node.label);
      else push(node, group);
    });
  };
  walk(adminMenuStructure, "Administration");
  walk(moduleMenuStructure, "Modules");
  return out;
};

// Texte d'infobulle effectif : override admin > défaut > vide.
// `config` = map { path: { hint, ordre, masque } } renvoyée par l'API.
export const getMenuHint = (path, config = {}) =>
  (config && config[path] && config[path].hint) ||
  DEFAULT_MENU_HINTS[path] ||
  "";

// =============================================
// CONSTRUCTEUR DE MENU — catalogue + structure base + assemblage
// =============================================

// Icônes proposées pour les chapitres (map nom -> composant). Repli : HiFolder.
export const CHAPTER_ICONS = {
  folder: HiFolder,
  database: HiDatabase,
  cube: HiCube,
  chart: HiChartBar,
  trending: HiTrendingUp,
  cart: HiShoppingCart,
  truck: HiTruck,
  tag: HiTag,
  users: HiUserGroup,
  building: HiOfficeBuilding,
  mail: HiMail,
  document: HiDocumentReport,
  money: HiCurrencyDollar,
  grid: HiViewGrid,
  device: HiDeviceMobile,
  sparkles: HiSparkles,
};
export const chapterIcon = (name) => CHAPTER_ICONS[name] || HiFolder;

const slug = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || "chap";

// Catalogue = TOUS les onglets connus du code (hors espace perso), avec leur
// permission (moduleKey explicite sinon déduite du path).
export const getMenuCatalog = () => {
  const out = [];
  const seen = new Set();
  const add = (item) => {
    if (!item?.path || seen.has(item.path)) return;
    seen.add(item.path);
    out.push({
      path: item.path,
      label: item.label,
      icon: item.icon || null,
      permKey: item.moduleKey || moduleForPath(item.path) || null,
    });
  };
  const walk = (nodes) =>
    (nodes || []).forEach((n) =>
      n.type === "subgroup" ? walk(n.items) : add(n),
    );
  walk(adminMenuStructure);
  walk(moduleMenuStructure);
  return out;
};

// ── Dossier « Terrain » du menu par défaut (décision client du 10/09/2026) ───
// Tout ce qui se prépare, se compte ou se reçoit AVEC UN COLLECTEUR tient dans
// un seul dossier, un sous-dossier par métier. Chaque sous-dossier porte à la
// fois l'écran qui CRÉE les demandes envoyées à l'application mobile et celui
// qui SUIT ce qui est en cours sur les collecteurs — c'est le même geste de
// travail, ils ne doivent pas être à deux endroits du menu.
// Les onglets cités ici sont retirés des chapitres dérivés de la structure code
// (sinon ils apparaîtraient deux fois).
const DOSSIER_TERRAIN = [
  { key: "terrain", label: "Terrain", icon: "truck", parent: null, items: [] },
  {
    key: "terrain_reappro",
    label: "Réappro",
    icon: "cart",
    parent: "terrain",
    // Listes de réappro = création des demandes (envoyées au collecteur) ET
    // suivi des listes en cours / terminées, avec les statistiques préparateurs.
    items: [
      "/demandes-reappro",
      "/admin/suivi-reappro",
      "/reappro-mecalac",
      "/admin/analyse-reappro",
      "/admin/reappro-local",
    ],
  },
  {
    key: "terrain_prepa",
    label: "Préparation de commande",
    icon: "cube",
    parent: "terrain",
    items: ["/preparation-manuelle", "/admin/suivi-preparation"],
  },
  {
    key: "terrain_reception",
    label: "Réception de commande",
    icon: "truck",
    parent: "terrain",
    items: ["/reception-manuelle", "/admin/suivi-receptions"],
  },
  {
    key: "terrain_bipage",
    label: "Bipage",
    icon: "device",
    parent: "terrain",
    // UNIQUEMENT le bipage terrain (app mobile) : les demandes envoyées aux
    // collecteurs, et le suivi de ce qu'ils ont rendu.
    // ⚠️ Ni « /admin/suivi-bipage » ni « /admin/bipages » : ces deux-là suivent
    // le comptage d'INVENTAIRE par zone et se vident à chaque réinitialisation
    // d'inventaire. Ils appartiennent au chapitre « Inventaire Zones » et n'en
    // bougent pas — c'est un autre module, un autre cycle de vie.
    items: ["/admin/demandes-bipage", "/admin/suivi-demandes-bipage"],
  },
];

// Structure par défaut (repli si la base est vide) = calque de la structure
// code, plus le dossier « Terrain » ci-dessus.
export const getDefaultLayout = () => {
  const chapitres = [];
  const topItems = [];
  // Onglets déjà rangés dans « Terrain » : ils ne repartent pas dans leur
  // chapitre d'origine.
  const prisParTerrain = new Set(DOSSIER_TERRAIN.flatMap((d) => d.items));
  const walkTop = (nodes) =>
    (nodes || []).forEach((n) => {
      if (n.type === "subgroup") {
        const items = (n.items || [])
          .map((i) => i.path)
          .filter((path) => path && !prisParTerrain.has(path));
        // Un chapitre vidé par le regroupement disparaît (ex. « Réappro »,
        // « Préparation », « Réception » de la structure code).
        if (items.length) {
          chapitres.push({
            key: slug(n.label),
            label: n.label,
            icon: "",
            parent: null,
            items,
          });
        }
      } else if (n.path && !prisParTerrain.has(n.path)) {
        topItems.push(n.path);
      }
    });
  walkTop(adminMenuStructure);
  walkTop(moduleMenuStructure);
  if (topItems.length) {
    chapitres.unshift({
      key: "general",
      label: "Général",
      icon: "",
      parent: null,
      items: topItems,
    });
  }
  // « Terrain » juste après « Général » : c'est le travail quotidien.
  chapitres.splice(topItems.length ? 1 : 0, 0, ...DOSSIER_TERRAIN.map((d) => ({ ...d })));
  return { chapitres, masques: [] };
};

// Onglets admin visibles par un responsable (gestion d'équipe).
const RESP_PATHS = ["/admin/users", "/admin/equipes", "/admin/taches"];

// Un utilisateur voit-il un onglet du catalogue ? (mêmes règles que canSeeAdminItem)
export const catalogItemVisible = (userInfo, cat) => {
  if (!userInfo) return false;
  if (userInfo.role === "responsable" && RESP_PATHS.includes(cat.path)) return true;
  if (cat.permKey) return hasModulePermission(userInfo, cat.permKey, "read");
  return isAdmin(userInfo); // onglet sans permission -> admin uniquement
};

// Assemble les sections à rendre dans la sidebar à partir de la structure base.
// Retourne UNE section sans titre contenant des sous-groupes (Mon espace + chapitres
// + Non classé), chacun filtré par les permissions de l'utilisateur.
export const buildSidebar = (userInfo, layout, hints) => {
  if (!userInfo) return [];
  const catalog = getMenuCatalog();
  const byPath = new Map(catalog.map((c) => [c.path, c]));
  const lay =
    layout && Array.isArray(layout.chapitres) && layout.chapitres.length
      ? layout
      : getDefaultLayout();
  const masques = new Set(lay.masques || []);
  const placed = new Set();

  const subgroups = [];

  // 1. Mon espace (fixe).
  subgroups.push({
    type: "subgroup",
    label: "Mon espace",
    icon: HiChatAlt2,
    items: PERSONAL_ITEMS.map((it) => ({ ...it })),
  });

  // 1 bis. Espace commercial (fixe, hors constructeur de menu).
  if (estCommercial(userInfo)) {
    subgroups.push({
      type: "subgroup",
      label: "Espace commercial",
      icon: HiTrendingUp,
      items: COMMERCIAL_ITEMS.map((it) => ({ ...it })),
    });
  }

  // 2. Dossiers définis par l'admin (ou par l'utilisateur en mode perso).
  //    L'arborescence est stockée À PLAT : chaque dossier porte la `key` de son
  //    parent (null = racine). On la remonte ici en sous-groupes imbriqués.
  //    Un dossier n'est rendu que s'il reste quelque chose dedans : des onglets
  //    visibles, ou un sous-dossier qui l'est.
  const chapitres = lay.chapitres || [];
  const enfantsDe = new Map();
  chapitres.forEach((ch) => {
    const parent = ch.parent || null;
    if (!enfantsDe.has(parent)) enfantsDe.set(parent, []);
    enfantsDe.get(parent).push(ch);
  });

  const vusChapitres = new Set();
  const construireDossier = (ch) => {
    vusChapitres.add(ch.key);
    const items = [];
    for (const path of ch.items || []) {
      placed.add(path);
      if (masques.has(path)) continue;
      const cat = byPath.get(path);
      if (!cat || !catalogItemVisible(userInfo, cat)) continue;
      items.push({ label: cat.label, path: cat.path, icon: cat.icon });
    }
    // Les sous-dossiers viennent APRÈS les onglets du dossier : on voit d'abord
    // les liens directs, puis les regroupements.
    const enfants = (enfantsDe.get(ch.key) || [])
      .map(construireDossier)
      .filter(Boolean);
    if (!items.length && !enfants.length) return null;
    return {
      type: "subgroup",
      label: ch.label || "Sans nom",
      icon: chapterIcon(ch.icon),
      items: [...items, ...enfants],
    };
  };

  (enfantsDe.get(null) || []).forEach((ch) => {
    const noeud = construireDossier(ch);
    if (noeud) subgroups.push(noeud);
  });
  // Filet : un dossier dont le parent a disparu (document ancien, édition
  // concurrente) remonte à la racine plutôt que d'emporter ses onglets avec lui.
  chapitres.forEach((ch) => {
    if (vusChapitres.has(ch.key)) return;
    const noeud = construireDossier(ch);
    if (noeud) subgroups.push(noeud);
  });

  // 3. Non classé : onglets du catalogue non rangés, non masqués, visibles.
  const nonClasses = catalog
    .filter(
      (c) => !placed.has(c.path) && !masques.has(c.path) && catalogItemVisible(userInfo, c),
    )
    .map((c) => ({ label: c.label, path: c.path, icon: c.icon }));
  if (nonClasses.length) {
    subgroups.push({
      type: "subgroup",
      label: "Non classé",
      icon: HiFolder,
      items: nonClasses,
    });
  }

  return [{ type: "section", label: "", collapsible: false, items: subgroups }];
};

// Applique l'ordre + le masquage définis par l'admin aux menus (getUserMenus).
// - trie les items de chaque sous-groupe par `ordre` (null => ordre du code) ;
// - retire les items masqués ; supprime les sous-groupes/sections devenus vides.
const isMasque = (config, path) => !!(config && config[path] && config[path].masque);
const ordreOf = (config, path) => {
  const o = config && config[path] ? config[path].ordre : null;
  return o === null || o === undefined ? null : o;
};
const trierEtFiltrer = (items, config) =>
  (items || [])
    .filter((it) => !(it.path && isMasque(config, it.path)))
    .map((it, i) => ({ it, i }))
    .sort((a, b) => {
      const oa = a.it.path ? ordreOf(config, a.it.path) : null;
      const ob = b.it.path ? ordreOf(config, b.it.path) : null;
      if (oa === null && ob === null) return a.i - b.i;
      if (oa === null) return 1;
      if (ob === null) return -1;
      return oa - ob || a.i - b.i;
    })
    .map((x) => x.it);

export const applyMenuConfig = (menus, config = {}) => {
  const out = [];
  for (const section of menus || []) {
    const nodes = [];
    for (const node of section.items || []) {
      if (node.type === "subgroup") {
        const its = trierEtFiltrer(node.items, config);
        if (its.length) nodes.push({ ...node, items: its });
      } else if (!(node.path && isMasque(config, node.path))) {
        nodes.push(node);
      }
    }
    if (nodes.length) out.push({ ...section, items: nodes });
  }
  return out;
};